import { KEY_SEPARATOR, LIVE_SNAPSHOT_ID } from '../common/constants';

export const getSnapshotId = (snapshot, liveSnapshot) => {
  return snapshot.id === liveSnapshot.id ? LIVE_SNAPSHOT_ID : snapshot.id;
};

export const sleep = (milliseconds) => new Promise((resolve) => setTimeout(resolve, milliseconds));

export const zip = (a, b) => a.map((x, i) => [x, b[i]]);

export const isEmpty = (reportData) => {
  return !reportData || !reportData.reportKeys || !reportData.reportKeys.length;
};

export const getForEachSnapshot = (items, snapshots, liveSnapshot) => {
  return [
    ...new Set(
      items
        .map((item) =>
          snapshots.map((snapshot) => `${getSnapshotId(snapshot, liveSnapshot)}${KEY_SEPARATOR}${item}`)
        )
        .flat()
    ),
  ];
};



// WEBPACK FOOTER //
// ./src/components/reports/utils/index.js